import React, { useEffect, useState } from 'react';
import {
	DialogContentText, Button, Dialog, DialogActions, DialogContent, DialogTitle, Card, CardContent, Typography, createMuiTheme, MuiThemeProvider,
	Avatar, Grid
} from '@material-ui/core';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import PersonIcon from '@material-ui/icons/Person';
import PublicIcon from '@material-ui/icons/Public';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { listAmzHeross } from '../../../graphql/queries';

interface IExpertAction {
	open: any;
	expertClose: any;
	client: any;
}

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		card: {
			minWidth: 275,
			margin: 5
		},
		title: {
			fontSize: 14
		},
		typoStyle: {
			// background: "rgb(234, 237, 237)",
			paddingBottom: 20,
			paddingLeft: 8
		},
		large: {
			width: "100%",
			height: "86%",
		}
	})
);
const themes = createMuiTheme({
	overrides: {
		MuiCardContent: {
			root: {
				padding: 9,
				"&:last-child": {
					paddingBottom: 11
				}
			}
		},
		MuiTypography: {
			h6: {
				fontSize: "0.9rem"
			}
		},
		MuiAvatar: {
			root: {
				borderRadius: "0%"
			}
		},
		MuiButton: {
			root: {
				padding: "8px 32px !important",
				margin: 4
			}
		},
		MuiSvgIcon: {
			root: {
				verticalAlign: 'bottom',
				fontSize: '1.3rem'
			}
		}
	}
});

const ExpertAction: React.FC<IExpertAction> = ({ open, expertClose, client }) => {
	const classes = useStyles();
	const [expertData, setExpertData] = useState([]);

	useEffect(() => {
		listExpert();
	}, []);

	const listExpert = async () => {
		// Query using a parameter
		const userMutation = client.query({
			query: listAmzHeross,
			variables: {
				// "filter": {
				// 	"category": { "contains": "AWS Machine Learning Hero" }
				// },
				"limit": 200
			}
		});
		const mutationResponse = await Promise.all([userMutation]);
		setExpertData(mutationResponse[0].data.listAmzHeros.items);
	}

	return (
		<MuiThemeProvider theme={themes}>
			<Dialog open={open} onClose={expertClose} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">AWS Expert list</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Please click the icon you want to expert this chat content.
          			</DialogContentText>
					{
						expertData.map((data: any, index: any) => (
							<Card key={index} className={classes.card}>
								<CardContent>
									<Grid container spacing={1}>
										<Grid item xs={4}>
											<Avatar alt="Remy Sharp" src={data.imageUrl} className={classes.large} />
											<Button variant="outlined" color="primary">
												<a target="_blank" href={data.connectLink} style={{ color: "#3f51b5", textDecoration: "none" }}><InsertCommentIcon />Connect</a>
											</Button>
										</Grid>
										<Grid item xs={8}>
											<Grid item xs={12}>
												<Typography
													className={classes.title}
													color="textSecondary"
													gutterBottom
												>
													<PersonIcon /> {data.term}, {data.designation}<br />
													<PublicIcon /> {data.city}<br />
													<AssignmentTurnedInIcon /> {data.since}
												</Typography>
											</Grid>
											<Grid item xs={12}>
												<Typography
													className={classes.typoStyle}
													variant="h6"
													component="h6"
												>
													{data.content}
												</Typography>
											</Grid>
										</Grid>
									</Grid>
								</CardContent>
							</Card>
						))
					}
				</DialogContent>
				<DialogActions>
					<Button onClick={expertClose} color="primary" style={{outline:'0'}}>
						Done
          			</Button>
				</DialogActions>
			</Dialog>
		</MuiThemeProvider >
	);
};

export default ExpertAction;